export const DEFAULT_DECIMAL_MIN = 0.0;
export const DEFAULT_DECIMAL_MAX = 1.0;
export const DEFAULT_INTEGER_MIN = 0;
export const DEFAULT_INTEGER_MAX = 1000;
export const DEFAULT_DOLLAR_MIN = 0;
export const DEFAULT_DOLLAR_MAX = 100_000_000_000_000;

export const DOLLAR_THRESHOLD_MLA_FORMULA_PLACEHOLDERS = ['amount', 'max_amount'];
